<template>
  <Modal v-model="visible" title="本期扣款" width="700" class="my-modal top" :mask-closable="false" :footer-hide="true">
    <Form :model="formData" ref="infoFormRef" class="page-form" :label-width="90" v-if="visible">
      <div class="">
        <FormItem label="保单号：" class="form-item" style="width: 37%">
          <span>{{ formData.policyNo }}</span>
        </FormItem>

        <FormItem label="保单年度：" :label-width="110" class="form-item" style="width: 26.33%" v-if="policyType == 'insurance'">
          <span>{{ formData.commissionIndex }}</span>
        </FormItem>

        <FormItem label="交费期次：" :label-width="110" class="form-item" style="width: 33.33%" v-if="policyType == 'insurance'">
          <span>{{ formData.commissionPeriods }}</span>
        </FormItem>
      </div>

      <div class="less">
        <FormItem label="结算状态：" class="form-item" style="width: 40%">
          <span>{{ formData.settlementStatus == '1' ? '已结算' : '未结算' }}</span>
        </FormItem>

        <FormItem label="结算费用：" class="form-item" style="width: 40%" v-if="policyType == 'insurance'">
          <span>{{ commissionPrice }}</span
          >元
        </FormItem>
      </div>

      <div class="less">
        <FormItem label="退费金额：" prop="fee" class="form-item" style="width: 40%">
          <Input
            v-if="policyType == 'insurance'"
            type="number"
            @on-change="countCommissionPrice"
            v-model="formData.fee"
            style="width: 80%"
            placeholder="请输入"
          />
          <span v-if="policyType == 'group'">{{ formData.refundFee }}</span>
          <span class="unit">元</span>
        </FormItem>

        <FormItem
          label="本期扣除费用："
          prop="commissionPrice"
          :rules="$units.formRule.required('请输入本期扣除费用', 'change', 'number')"
          :label-width="120"
          class="form-item"
          style="width: 40%"
          v-if="policyType == 'insurance'"
        >
          <InputNumber v-model="formData.commissionPrice" :min="0" placeholder="请输入" style="width: 80%"></InputNumber>
          <span class="unit">元</span>
        </FormItem>

        <FormItem
          label="本期扣除费用："
          prop="commissionPrice"
          :rules="$units.formRule.required('请输入本期扣除费用', 'change', 'number')"
          :label-width="120"
          class="form-item"
          style="width: 40%"
          v-else
        >
          <InputNumber v-model="formData.commissionPrice" :min="0" placeholder="请输入" style="width: 80%"></InputNumber>
          <span class="unit">元</span>
        </FormItem>
      </div>

      <div class="less">
        <FormItem label="扣款原因：" prop="deductType" :rules="$units.formRule.required('请选择扣款原因', 'change')" style="width: 100%">
          <Select v-model="formData.deductType" placeholder="请选择" filterable clearable transfer>
            <Option value="1">退保</Option>
            <Option value="2" v-if="policyType == 'insurance'">部分退保</Option>
            <Option value="3" v-if="policyType == 'insurance'">退现价</Option>
            <Option value="4">其他</Option>
          </Select>
        </FormItem>
      </div>

      <div class="full" v-if="formData.deductType == 4">
        <FormItem label="" prop="deductMsg" :rules="$units.formRule.required('请填写原因')" style="width: 100%">
          <Input type="textarea" :autosize="{ minRows: 3, maxRows: 5 }" v-model="formData.deductMsg" placeholder="请输入" />
        </FormItem>
      </div>
    </Form>

    <div class="ivu-modal-footer">
      <Button @click="visible = false">取消</Button>
      <Button type="primary" @click="ok" :loading="loading">确定</Button>
    </div>
  </Modal>
</template>

<script>
import { pageTool, common } from '@/api/mixins';
export default {
  mixins: [pageTool, common],
  props: ['policyType'],
  data() {
    return {
      commissionPrice: 0,
      formData: {
        commissionPrice: null,
        deductType: '',
        deductMsg: ''
      },
      visible: false,
      loading: false,
      edit: false
    };
  },
  methods: {
    open(item, edit) {
      this.edit = edit;
      if (edit && this.policyType == 'insurance') {
        this.getDetail(item.deductLogId, item);
      } else {
        let itemObj = JSON.parse(JSON.stringify(item));
        itemObj.fee = Math.abs(itemObj.fee);
        itemObj.commissionPrice = itemObj.commissionPrice?Math.abs(itemObj.commissionPrice):0;
        this.formData = itemObj;
        this.commissionPrice = Number(itemObj.commissionPrice);
      }
      this.visible = true;
    },

    getDetail(id, item) {
      this.$http({
        url: '/buz/commissionLog/read/detail',
        type: 'GET',
        data: {
          id
        }
      }).then(res => {
        this.formData.policyNo = res.data.policyNo;
        this.formData.commissionIndex = res.data.commissionIndex;
        this.formData.commissionPeriods = res.data.commissionPeriods;
        this.formData.settlementStatus = res.data.settlementStatus;
        this.commissionPrice = res.data.commissionPrice;
        this.formData.fee = Math.abs(item.fee);
        this.formData.commissionPrice = Math.abs(item.commissionPrice);
        this.formData.deductType = item.deductType;
        this.formData.deductMsg = item.deductMsg;
        this.formData.id = item.id;
        this.formData.commission = res.data.commission;
      });
    },

    countCommissionPrice(e) {
      let num = Number(e.target.value) * Number(this.formData.commission);
      this.$set(this.formData, 'commissionPrice', Number(num.toFixed(2)));
    },

    ok() {
      this.$refs.infoFormRef.validate().then(isok => {
        if (!isok) {
          return;
        }
        let data = JSON.parse(JSON.stringify(this.formData));
        let url = '';
        let params = {
          commissionPrice: '-' + data.commissionPrice,
          deductType: data.deductType,
          deductMsg: data.deductType == 4 ? data.deductMsg : ''
        };
        if(this.policyType == 'insurance') {
          params.fee = '-' + data.fee
        }else if(this.policyType == 'group' && !this.edit ){
          params.fee = '-' + data.refundFee
        }
        if (this.edit) {
          params.id = data.id;
          url = '/buz/commissionLog/changeDeduct';
        } else {
          params.commissionLogId = data.id;
          url = '/buz/commissionLog/deductCommission';
        }
        this.$http({
          url,
          type: 'POST',
          data: params
        }).then(res => {
          this.visible = false;
          this.$emit('success');
        });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.form-item {
  .unit {
    margin-left: 10px;
    font-size: 14px;
  }
}
</style>
